import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import { tw } from "@careinfo/tailwind";

const DeliveryChargeTemplateListComponent = loadable(
  () => import("../../components/Template/TemplateList")
);

const DeliveryChargeTemplateList = () => {
  return (
    <>
      <div className={tw `w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}>
        <StatusIcon />
        <span className={tw `text-[#5E5757] font-bold text-xl`}>Rate Template</span>
      </div>
      <DeliveryChargeTemplateListComponent />
    </>
  );
};



export default DeliveryChargeTemplateList